/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Service
 */
export interface Service {
  /**
   *
   * @type {string}
   * @memberof Service
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof Service
   */
  url: string
  /**
   *
   * @type {number}
   * @memberof Service
   */
  price?: number
  /**
   *
   * @type {string}
   * @memberof Service
   */
  sortOrder: string
  /**
   *
   * @type {string}
   * @memberof Service
   */
  disabledFromMenu: string
  /**
   *
   * @type {string}
   * @memberof Service
   */
  disabledInArchivePage: string
  /**
   *
   * @type {Array<Service>}
   * @memberof Service
   */
  children?: Array<Service>
}

/**
 * Check if a given object implements the Service interface.
 */
export function instanceOfService(value: object): value is Service {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('url' in value) || value['url'] === undefined) return false
  if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false
  if (!('disabledFromMenu' in value) || value['disabledFromMenu'] === undefined)
    return false
  if (
    !('disabledInArchivePage' in value) ||
    value['disabledInArchivePage'] === undefined
  )
    return false
  return true
}

export function ServiceFromJSON(json: any): Service {
  return ServiceFromJSONTyped(json, false)
}

export function ServiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Service {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    url: json['url'],
    price: json['price'] == null ? undefined : json['price'],
    sortOrder: json['sortOrder'],
    disabledFromMenu: json['disabledFromMenu'],
    disabledInArchivePage: json['disabledInArchivePage'],
    children:
      json['children'] == null
        ? undefined
        : (json['children'] as Array<any>).map(ServiceFromJSON),
  }
}

export function ServiceToJSON(value?: Service | null): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    url: value['url'],
    price: value['price'],
    sortOrder: value['sortOrder'],
    disabledFromMenu: value['disabledFromMenu'],
    disabledInArchivePage: value['disabledInArchivePage'],
    children:
      value['children'] == null
        ? undefined
        : (value['children'] as Array<any>).map(ServiceToJSON),
  }
}
